import { Q as attr, R as ensure_array_like, S as escape_html, P as pop, N as push, T as fallback, V as store_get, W as unsubscribe_stores, X as bind_props, Y as stringify, Z as head, _ as slot } from "../../chunks/index.js";
import { D as DownloadButton } from "../../chunks/DownloadButton.js";
import { P as PurchaseButton } from "../../chunks/PurchaseButton.js";
import { L as Link } from "../../chunks/Link.js";
import Icon from "../../chunks/icon3.js";
import { A as Animate } from "../../chunks/Animate.js";
import { p as page } from "../../chunks/stores.js";
const menu = [
  {
    name: "Features",
    link: "/features"
  },
  {
    name: "Pricing",
    link: "/pricing"
  },
  {
    name: "Support",
    link: "/support"
  }
];
function Logo($$payload) {
  $$payload.out += `<a href="/" class="flex items-center space-x-2 !text-inherit"><img${attr("src", Icon)} class="w-8 h-8" alt="logo"> <span class="text-2xl font-display font-bold">Glimmr</span></a>`;
}
function Footer($$payload, $$props) {
  push();
  const each_array = ensure_array_like(menu);
  $$payload.out += `<footer class="w-full py-12 md:py-24 bg-teal-950 text-white z-10 flex flex-col items-center"><div class="container mx-auto px-4 relative flex items-center flex-col text-center gap-12"><div class="flex flex-col-reverse items-start gap-24 md:flex-row">`;
  Logo($$payload);
  $$payload.out += `<!----> <div class="flex flex-col items-start gap-4"><p class="font-display uppercase opacity-70 text-xs">Directory</p> <!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let { name, link } = each_array[i];
    Link($$payload, {
      to: link,
      children: ($$payload2) => {
        $$payload2.out += `<!---->${escape_html(name)}`;
      },
      $$slots: { default: true }
    });
  }
  $$payload.out += `<!--]--></div> <div class="flex flex-col items-start gap-4"><p class="font-display uppercase opacity-70 text-xs">Contact</p> `;
  Link($$payload, {
    to: "mailto:support@glimmr.app",
    children: ($$payload2) => {
      $$payload2.out += `<!---->Email us`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div> <div class="flex items-center gap-2">`;
  DownloadButton($$payload, { size: 4, background: "dark" });
  $$payload.out += `<!----> `;
  PurchaseButton($$payload, { size: 4, background: "dark" });
  $$payload.out += `<!----></div></div> <div class="flex flex-col gap-4 items-center">`;
  Link($$payload, {
    to: "/privacy",
    children: ($$payload2) => {
      $$payload2.out += `<!---->Privacy Policy`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> <p class="font-display opacity-70">© ${escape_html((/* @__PURE__ */ new Date()).getFullYear())} Glimmr LLC / All rights reserved.</p></div></div></footer>`;
  pop();
}
function Navbar($$payload, $$props) {
  push();
  var $$store_subs;
  let showDownloadButton = fallback($$props["showDownloadButton"], true);
  let showPurchaseButton = fallback($$props["showPurchaseButton"], true);
  const each_array = ensure_array_like(menu);
  $$payload.out += `<div class="section-container flex items-center justify-center sticky top-0 z-50 bg-transparent !py-4 pointer-events-none"><div class="transition mx-auto text-white pointer-events-auto"><div${attr("class", `mx-auto ${stringify("bg-teal-950 text-white")} transition backdrop-blur-3xl p-4 px-8 rounded-3xl`)}><div class="flex items-center justify-between flex-col md:flex-row gap-4 lg:gap-12">`;
  Animate($$payload, {
    children: ($$payload2) => {
      Logo($$payload2);
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> <div class="flex items-center gap-8"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let { name, link } = each_array[i];
    const active = store_get($$store_subs ??= {}, "$page", page).url.href.replace(store_get($$store_subs ??= {}, "$page", page).url.origin, "") === link;
    Animate($$payload, {
      delay: (i + 1) * 0.1 + "s",
      children: ($$payload2) => {
        Link($$payload2, {
          to: link,
          class: active ? "!text-teal-400" : "",
          children: ($$payload3) => {
            $$payload3.out += `<!---->${escape_html(name)}`;
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
  }
  $$payload.out += `<!--]--></div> `;
  DownloadButton($$payload, { size: 2 });
  $$payload.out += `<!----></div></div></div></div>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, { showDownloadButton, showPurchaseButton });
  pop();
}
function _layout($$payload, $$props) {
  head($$payload, ($$payload2) => {
    $$payload2.out += `<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,1,200">`;
  });
  $$payload.out += `<div class="fade-in bg-white">`;
  Navbar($$payload, {});
  $$payload.out += `<!----> <!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----> `;
  Footer($$payload);
  $$payload.out += `<!----></div>`;
}
export {
  _layout as default
};
